var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3125 31.9939L12.8191 28.5616L19.434 21.8287C20.2597 20.9883 21.0424 20.0908 21.6282 19.1259C22.3007 18.0184 22.6076 17.1272 22.5882 15.919C22.5608 14.2185 21.607 12.5939 20.182 11.2L18.6354 9.68715L12.2928 3.45569L15.6877 0.000270457L23.6349 7.82474C25.4929 9.5024 26.73 11.5288 27.1854 13.8531C27.3353 14.6184 27.3555 15.1332 27.3665 15.8782C27.4204 19.5362 26.1271 22.0036 24.026 24.1424L20.2825 27.9531L16.3125 31.994L16.3125 31.9939Z",
    fill: "#FE5840",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3313 13.6259L18.3579 18.3095L5.57478 18.2711L5.63333 13.706L18.3313 13.6259Z",
    fill: "#FE5840",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextArrow);
export default __webpack_public_path__ + "static/media/textArrow.9926e77345af0816744a7b903531b541.svg";
export { ForwardRef as ReactComponent };